/* RESPONSIBLE TEAM: team-actions */
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import { ReactRoute } from 'embercom/lib/react-route';

/**
 * Route for the data connector health page at custom-actions/:id/health.
 * Always renders the React health dashboard via ReactRoute.
 * The health page is read-only, so no dirty state tracking is needed.
 */
class CustomActionsCustomActionHealth extends SettingsRoute {
  @service declare permissionsService: $TSFixMe;
  @service declare intercomEventService: $TSFixMe;

  reactEnabled() {
    return true;
  }

  async beforeModel(transition: Transition) {
    this.permissionsService.ensurePermissionWhenTransitioning(
      'can_access_developer_hub',
      transition,
      'apps.app.settings',
    );
  }

  model(params: { id: string }) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'viewed',
      object: 'data_connector_health',
      action_id: params.id,
    });
    return null;
  }
}

export default ReactRoute(CustomActionsCustomActionHealth);
